import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";
import { BRAND } from "../../constants/brand";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/faqs", label: "FAQs" },
  { to: "/vendor/register", label: "For Print Shops" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-neutral-200 bg-white/85 backdrop-blur-md" data-testid="site-navbar">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
          <img src={BRAND.logo} alt="EarlyPrint logo" className="h-9 w-9 rounded-full" />
          <span className="font-display text-lg font-bold tracking-tight">
            Early<span className="text-lime-500">Print</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              className={({ isActive }) =>
                `rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive ? "text-neutral-950" : "text-neutral-600 hover:text-neutral-950"
                }`
              }
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-2 md:flex">
          <Link
            to="/login"
            className="rounded-md border border-neutral-300 px-4 py-2 text-sm font-semibold text-neutral-900 transition-colors hover:border-neutral-900"
            data-testid="nav-login-btn"
          >
            Login
          </Link>
          <Link
            to="/signup"
            className="btn-offset inline-flex items-center gap-1 rounded-md bg-lime-400 px-4 py-2 text-sm font-bold text-neutral-950 hover:bg-lime-300"
            data-testid="nav-get-quote-btn"
          >
            Get a Quote <ChevronRight size={16} />
          </Link>
        </div>

        <button
          className="md:hidden"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="border-t border-neutral-200 bg-white md:hidden">
          <div className="flex flex-col p-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-medium ${isActive ? "bg-neutral-100 text-neutral-950" : "text-neutral-700"}`
                }
                data-testid={`mnav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <div className="mt-2 grid grid-cols-2 gap-2">
              <Link to="/login" onClick={() => setOpen(false)} className="rounded-md border border-neutral-300 px-3 py-2 text-center text-sm font-semibold" data-testid="mnav-login">
                Login
              </Link>
              <Link to="/signup" onClick={() => setOpen(false)} className="rounded-md bg-lime-400 px-3 py-2 text-center text-sm font-bold" data-testid="mnav-signup">
                Get Quote
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
